<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="工序详情"
      id-key="UserId"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
      >
      
      <el-table-column
        prop="Pname"
        label="产品名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProgrammeName"
        label="工艺方案名称"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="ProcessSn"
        label="工序顺序"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="ProcessName" label="工序名称" min-width="120">
      </el-table-column>
      <el-table-column
        prop="ProductionType"
        label="自制工序或者委外工序"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <el-select v-model="row.ProcessType" @change="changeProcessType(row)" :disabled="disabled">
            <el-option key="a1" label="自制工序" :value="0"></el-option>
            <el-option key="a2" label="委外工序" :value="1"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
        <template slot-scope="{ row }">
          <div class="flex" v-show="row.ProcessType === 1">
            <span v-if="disabled">{{ row.TradeUnitName }}</span>
            <el-input v-else type="text" v-model="row.TradeUnitName" readonly />
            <el-button v-if="!disabled" type="primary" @click="selectCome(row)">选择</el-button>
          </div>
        </template>
      </el-table-column>
      </el-table>


     <template slot="footer">
        <el-button type="primary" @click="save" v-if="!disabled">确定</el-button>
      </template>

      <come-list-dialog
        @select="comeSelect"
        selectable
        :multiple="false"
        ref="comeListDialog"
        in-dialog
      />
    </common-dialog>

  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import comeListDialog from "@/components/basedata/business/come/listDialog";



export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    comeListDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
     tableData: [],
     currentRow: null
    };
  },
  methods: {
    selectCome(row){
      this.currentRow = row;
      this.$refs.comeListDialog.open()
    },
    changeProcessType(row){
      console.log("row",row)
      if(row.T !== 0){
        row.T = 1;
      }
    },
    comeSelect(row) {
      console.log('row', row)
      this.currentRow.DpId = row.TradeUnitId;
      this.currentRow.TradeUnitName = row.FullName;
      if(this.currentRow.T !== 0){
        this.currentRow.T = 1;
      }
    },
    setTableData(row){
      let arr = [];
      row.Processes.forEach(item => {
        console.log('item.Sn', item)
        let o = {
          T: item.T == 1  ? 1 : 0,
          Pname: row.Pname,
          ProgrammeName: row.ProgrammeName,
          ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
          ProcessId: item.ProcessId,
          ProcessName: item.ProcessName,
          ProcessNo: item.ProcessNo,
          ProgrammeId: item.ProgrammeId,
          ProgrammeName: item.ProgrammeName,
          ProgrammeProcessId: item.ProgrammeProcessId,
          Stage: item.Stage,
          ProcessType: item.ProcessType == null ? "" : item.ProcessType,
          DpId: item.DpId ? item.DpId : 0,
          TradeUnitName: item.TradeUnitName ? item.TradeUnitName : "",

          ConvertRatio: item.ConvertRatio ? item.ConvertRatio : 1,
          Length: item.Length ? item.Length : 0,
          LossRate: item.LossRate ? item.LossRate : 0,
          MachineId: item.MachineId ? item.MachineId : 0,
          Multiple: item.Multiple ? item.Multiple : 0,
          PlanIn: item.PlanIn ? item.PlanIn : 0,
          PlanOut: item.PlanOut ? item.PlanOut : 0,
          PlanOutUnit: item.PlanOut ? item.PlanOut : "",
          RatedLoss: item.RatedLoss ? item.RatedLoss : 0,
          Requirement: item.Requirement ? item.Requirement : "",
          SnType: item.SnType ? item.SnType : 0,
          Status: item.Status ? item.Status : 0,
          Width: item.Width ? item.Width : 0,
          WorkDocId: item.WorkDocId ? item.WorkDocId : 0,
          WorkDocProcessId: item.WorkDocProcessId ? item.WorkDocProcessId : 0,

        }
        arr.push(o);
      })
      this.tableData = arr;
      console.log('set tableData', this.tableData)
    },
    save(){
      console.log('this.tableData',this.tableData)

      let data = this.tableData.filter(item => {
        
        return item.ProcessId >0
      })
      console.log('data',data)
      this.$emit('saved', data)
      this.close();
    }
  }
 
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
